<template>
    <div class="sidebar" :class="{ 'hide-sidebar': isCollapse }">
        <div style="overflow: scroll;height: 100%;">

            <el-menu :default-active="currentRoute" :collapse="isCollapse" unique-opened v-menu router
                     style="padding-bottom:45px">
                <template v-for="(item, index) in sidebarData">
                    <el-submenu :index="item.path" :key="index" v-if="item.children && item.show==1" :data-actived="item.menu_active">
                        <template slot="title">
                            <i :class="item.meta.icon"></i>
                            <span slot="title">{{ item.meta.name }}</span>
                        </template>
                        <template v-for="(sub, subIndex) in item.children">
                            <el-menu-item
                                v-if="!sub.children && sub.meta.isSidebarItem === '1'"
                                :index="sub.path"
                                :key="subIndex"
                                :data-actived="sub.menu_active"
                            >
                                <div class="chile-menu">{{ sub.meta.name }}</div>
                            </el-menu-item>
                            <el-submenu
                                :index="sub.path"
                                :key="subIndex"
                                v-else-if="sub.meta.isSidebarItem === '1'"
                                :data-actived="sub.menu_active"
                            >
                                <template slot="title">{{ sub.meta.name }}</template>
                                <template v-for="(s, i) in sub.children">
                                    <el-menu-item
                                        :index="s.path"
                                        :key="i"
                                        v-if="s.meta.isSidebarItem === '1'"
                                    >{{ s.meta.name }}
                                    </el-menu-item>
                                </template>
                            </el-submenu>
                        </template>
                    </el-submenu>

                    <el-menu-item
                        :index="item.path"
                        :key="index"
                        v-else-if="item.meta.isSidebarItem === '1'"
                        :data-actived="item.menu_active"
                    >
                        <template>
                            <i :class="item.meta.icon"></i>
                            <span slot="title"
                                  v-if="item.name != 'work'
                                  && item.name != 'noResponse'
                                  && item.name != 'noReply'
                                  && item.name != 'doctorSalary'
                                  && item.name != 'expertList'
                                  && item.name != 'meetTimeoutList'
                                  && item.name != 'apply'
                                  && item.name != 'meetHealthrecord' ">{{item.meta.name }}</span>
                            <span slot="title"
                                  v-if="item.name == 'expertList'" @click="centerDialogVisible = true">{{item.meta.name }}</span>

                            <span slot="title" v-if="item.name == 'work' && work_num < 1">{{ item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'work' && work_num > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'noResponse' && revesion_times_out_num < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'noResponse' && revesion_times_out_num > 0"
                                      class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'noReply' && no_reply_count < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'noReply' && no_reply_count > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'meetHealthrecord' && meet_record_count < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'meetHealthrecord' && meet_record_count > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'meetTimeoutList' && meet_timeout_count < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'meetTimeoutList' && meet_timeout_count > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'doctorSalary' && doctor_salary_esign_count < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'doctorSalary' && doctor_salary_esign_count > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }} </span></el-badge>

                            <span slot="title" v-if="item.name == 'apply' && user_apply_count < 1">{{item.meta.name }}</span>
                            <el-badge value="●" v-if="item.name == 'apply' && user_apply_count > 0" class="test"
                                      :max="99"><span>{{ item.meta.name }}</span></el-badge>

                        </template>
                    </el-menu-item>
                </template>
            </el-menu>
        </div>
        <!-- 打开关闭侧边栏 -->
        <div class="collapse-btn" @click="collapse">
            <span class="el-icon-arrow-right" :class="{ 'rotate-left': whetherRotate }"></span>
        </div>

        <audio ref="alertAudioEl" :autoplay="false" :src="audio_src" muted/>

        <div class="notice_content_box">
            <div role="alert" id="notice_box" class="el-message is-closable hidden"
                 :style="{'z-index': notice_box,'box-shadow': '0 0 4px 0 rgb(20 20 50 / 30%), 0 2px 4px 0 rgb(20 20 50  / 8%)'}" v-if="revesion_visible">
                <i class="el-message__icon el-icon-tickets el-message__icon_color"></i>
                <div class="el-message__content">
                    <p>有新的预约单了，快点去查看吧！</p>
                    <div>
                        <div style="float: left;">当前未处理预约单：<i>{{ revesion_num }}</i> 条！</div>
                        <div class="mssage_revestion el-button el-button--primary" id="go_reservation" style="">查看详情
                        </div>
                    </div>
                </div>

            </div>
            <div role="alert" id="notice_timesout_box" class="el-message is-closable hidden"
                 :style="{'z-index': timesout_box,'box-shadow': '0 0 4px 0 rgb(20 20 50 / 30%), 0 2px 4px 0 rgb(20 20 50  / 8%)'}" v-if="timeout_visible">
                <i class="el-message__icon el-icon-tickets el-message__icon_color"></i>
                <div class="el-message__content">
                    <p>有未响应的预约单请及时处理！</p>
                    <div>
                        <div style="float: left;">未响应预约单：<i>{{ revesion_times_out_num }}</i> 条！</div>
                        <div class="mssage_revestion el-button el-button--primary" id="go_noresponse">查看详情</div>
                    </div>
                </div>

            </div>
            <div role="alert" id="notice_apply_box" class="el-message is-closable hidden"
                 :style="{'z-index': apply_box,'box-shadow': '0 0 4px 0 rgb(20 20 50 / 30%), 0 2px 4px 0 rgb(20 20 50  / 8%)'}" v-if="apply_visible">
                <i class="el-message__icon el-icon-tickets el-message__icon_color"></i>
                <div class="el-message__content">
                    <p>有新的注册申请需要审核，快点去查看吧！</p>
                    <div>
                        <div style="float: left;">待审核注册申请：<i>{{ user_apply_count }}</i> 条！</div>
                        <div class="mssage_revestion el-button el-button--primary" id="go_apply" style="">查看详情
                        </div>
                    </div>
                </div>

            </div>
            <div v-for="(item,index) in doctor_users" role="alert" :id="gernerateId(index)"
                 class="el-message is-closable show notice_doctor_box"
                 :style="{'z-index': doctor_box,'box-shadow': '0 0 4px 0 rgb(20 20 50 / 30%), 0 2px 4px 0 rgb(20 20 50  / 8%)'}">
                <i class="el-message__icon el-icon-tickets el-message__icon_color"></i>
                <div class="el-message__content">
                    <p>有特属专家未及时回复特属服务对象消息请及时跟进！</p>
                    <div>
                        <div style="float: left;">
                            特属专家姓名：<i>{{ item.doctor_name }}</i>
                            特属服务对象姓名：<i>{{ item.user_name }}</i></div>
                        <div class="mssage_revestion el-button el-button--primary" @click="goChatDetail(index)">查看详情
                        </div>
                    </div>
                </div>

            </div>
            <div v-for="(item,index) in healthrecord_users" role="alert" :id="healthRecordGernerateId(index)"
                 class="el-message is-closable show notice_doctor_box"
                 :style="{'z-index': healthrecord_box,'box-shadow': '0 0 4px 0 rgb(20 20 50 / 30%), 0 2px 4px 0 rgb(20 20 50  / 8%)'}">
                <i class="el-message__icon el-icon-tickets el-message__icon_color"></i>
                <div class="el-message__content">
                    <p>有特属专家为特属服务对象更新健康档案了，快点去查看吧！</p>
                    <div>
                        <div style="float: left;">
                            特属专家姓名：<i>{{ item.doctor_name }}</i>
                            特属服务对象姓名：<i>{{ item.user_name }}</i></div>
                        <div class="mssage_revestion el-button el-button--primary" @click="gohealthrecordsDetail(index)">查看详情
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import store from '@/store/store';
import '@/store/modules/websocket';
import api from "@/api";
import {getUserInfos} from "@/utils/userInfos";
// import {env} from "@/store/modules/app";
import {check} from "@/utils/checkData";
import {removeToken} from "@/utils/auth";
import env from "@/api/env";
import {isMobile} from "@/api/order";


export default {
    name: "Sidebar",
    provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
        return {
            // reload: this.reload,
            reload: this.newReload,
        }
    },
    inject: ['rez_create', 'rez_status_change', 'rev_notice', 'voice_notice', 'chat_no_reply','health_record_log', 'user_apply'],
    props: {
        worknum: {
            type: Boolean
        },
        meet_finish: {
            type: Boolean
        }
    },
    data() {
        return {
            centerDialogVisible: false,
            // 系统导航栏默认打开
            isCollapse: true,
            work_num: 0,
            currentRoute: {},
            timer: '',
            revestion_duration: 0,
            audio_src: require('@/assets/mp3/default.wav'),
            default_audio: require('@/assets/mp3/default.wav'),
            apply_audio: require('@/assets/mp3/default.wav'),
            revesion_audio: require('@/assets/mp3/revesion.wav'), // 创建预约语音
            interrupt_audio: require('@/assets/mp3/interrupt.wav'), // 预约中断语音
            doctor_audio: require('@/assets/mp3/doctor.wav'), // 超时未回复语音
            noresponse_audio: require('@/assets/mp3/noresponse.wav'), // 超时未回复语音
            message_obj: null,
            message_box_is_open: false,
            revesion_num: 0,
            revesion_times_out_num: 0,
            notice_box: 2005,
            timesout_box: 2005,
            apply_box: 2005,
            doctor_box: 2005,
            healthrecord_box: 2005,
            doctor_users: [
                // {
                // doctor_name: '程教授',
                // user_name: '董理琨',
                // user_id: '04d68f40-6005-4ea8-a564-20dee9e3c2be',
                // doctor_id: '82a76c04-0e89-4d3b-9748-ebebaddb3a1a',
                //     id: ''
                // }
            ],
            healthrecord_users: [
                // {
                // doctor_name: '程教授',
                // user_name: '董理琨',
                // user_id: '04d68f40-6005-4ea8-a564-20dee9e3c2be',
                // doctor_id: '82a76c04-0e89-4d3b-9748-ebebaddb3a1a',
                //     id: ''
                // }
            ],
            first_index: 2052,
            second_index: 2010,
            is_voice_open: false,
            no_reply_count: 0,
            meet_record_count: 0,
            meet_timeout_count: 0,
            doctor_salary_esign_count: 0,
            user_apply_count: 0, // 注册申请待审核数量
            active_nav_name: "",
            apply_visible: true,
            timeout_visible: true,
            revesion_visible: true,
        };
    },
    created() {
        if (isMobile()) {
            // this.isCollapse = false
        }
        let routes = this.$store.getters.currentRoute.matched;
        this.active_nav_name = routes[1].name
    },
    mounted() {
        this.getTimesOutNumber();
        //this.$store.dispatch('websocket/connect',store.getters.token);

        this.collapse();

        this.newReload();
        this.noReplyReload();
        this.meetRecordReload();
        this.meetTimeoutReload();
        this.doctorSalaryEsignCount();
        this.userApplyCount();
        let user_info = getUserInfos();

        if (user_info && user_info.role_id != 1 && this.$store.getters.authUrl.length < 1) {
            this.getAuthUrl();
        }
        let _that = this;
        let noticeObj = document.getElementById('go_reservation')
        noticeObj.addEventListener('click', function () {
            _that.messageBoxClose(1)
            _that.rez_status_change()
            if (_that.$route.name !== 'workList') {
                _that.$router.replace({
                    name: "workList",
                    query: {}
                });
            }

        })

        let noResponseObj = document.getElementById('go_noresponse')
        noResponseObj.addEventListener('click', function () {
            _that.messageTimesOutClose(1)
            _that.rez_status_change()
            if (_that.$route.name !== 'noResponse') {
                _that.$router.replace({
                    name: "noResponse",
                    query: {}
                });
            } else {
                _that.rev_notice();
            }

        })

        let userApplyObj = document.getElementById('go_apply')
        userApplyObj.addEventListener('click', function () {
            _that.userApplyClose(1)
            localStorage.setItem('prev_page', 'notice_sidebar')
            if (_that.$route.name !== 'applyList') {
                _that.$router.push({
                    name: "applyList",
                    params: {
                        status: 1
                    }
                });
            } else {
                _that.user_apply(1)
            }

        })

    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    computed: {
        app() {
            return this.$store.getters.app//app.im_socket_url
        },
        message() {
            return this.$store.getters.message
        },
        whetherRotate() {
            return !this.isCollapse;
        },
        sidebarData() {
            const routes = this.$router.options.routes;

            let data = this.findRoute(routes, "/admin").children;
            let panelRouteData = this.findRoute(routes, "/panel");
            data = data.filter(d => d.path != "/admin/index");

            let i = 0
            data.forEach(e => {
                if (e.meta.noshowdropDown) {
                    data[i]["show"] = 2;
                } else {
                    data[i]["show"] = 1;
                }
                i++;
            });

            return data;
        },
    },
    watch: {
        voice_notice: {
            immediate: true,
            deep: true,
            handler(nVal, oVal) {
                if (oVal != undefined) {
                    if (nVal.is_voice) {
                        this.audio_src = this.default_audio
                        this.$refs['alertAudioEl'].autoplay = true
                        this.is_voice_open = true
                        // this.$refs['alertAudioEl'].play() // 语音提醒
                    } else {
                        this.$refs['alertAudioEl'].autoplay = false
                        this.is_voice_open = false
                    }
                }
            },
        },
        worknum: {
            immediate: true,
            deep: true,
            handler(nVal, oVal) {
                this.newReload()
            },
        },
        meet_finish: {
            immediate: true,
            deep: true,
            handler(nVal, oVal) {
                this.meetTimeoutReload()
            },
        },
        app: {
            handler(val) {

                let that = this;
                let status = 0 // 0=关闭，1=正常，2=正常重连
                let connectNum = 0
                const maxConnectNum = 5
                let im_socket_url = '';
                // if (process.env.NODE_ENV === 'production') {
                //     im_socket_url = 'ws://www.admin.ryiw.vip:8274';
                // } else {
                //     im_socket_url = 'ws://192.168.3.210:7676';
                // }
                im_socket_url = env.IM_SOCKET_URL
                if (status === 1) {
                    // resolve()
                } else if (!im_socket_url) {
                    reject(new Error('获取websocket地址失败'))
                } else if (connectNum >= maxConnectNum) {
                    reject(new Error('无法链接websocket服务器, 请刷新页面重试！'))
                } else {
                    const ws = new WebSocket(im_socket_url)
                    ws.addEventListener('open', e => {
                        status = 1
                        process.env.NODE_ENV !== 'production' && console.log('链接websocket', e)
                    })
                    ws.addEventListener('message', e => {
                        try {
                            const data = JSON.parse(e.data)
                            process.env.NODE_ENV !== 'production' && console.log(data)

                            if (data.type === 'init') {

                                // 绑定uid
                                let login_id = getUserInfos().id
                                ws.send(JSON.stringify({
                                    "type": "bindUid",
                                    "obj_id": login_id,
                                    "client_id": data.client_id,
                                    "value": data.client_id,
                                }))
                            } else if (data.type != 'ping') {
                                if (data.message.type == 'loginNotice') {
                                    // 强制退出
                                    this.$message({
                                        type: "warning",
                                        message: '当前账号已在其它浏览器登录！',
                                        duration: 5000,
                                    });
                                    setTimeout(function () {
                                        let params = {
                                            servername: 'Ruyi_AdminSystemServices',
                                            method: 'logout'
                                        }
                                        that.$api.service(params).then(() => {
                                            removeToken();
                                            that.$store.commit("REMOVE_TOKEN");
                                            that.$router.replace("/login");
                                        });
                                        that.$store.dispatch('websocket/close')
                                    }, 5000)
                                }
                                if (data.message.value.indexOf('create reservation') > -1) {
                                    that.revesion_visible = true
                                    // 新建预约单
                                    that.work_num = that.work_num + 1;
                                    that.rez_create()
                                    if (that.is_voice_open) {
                                        that.audio_src = that.revesion_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }
                                    if (!that.message_box_is_open) {
                                        that.messageBoxOpen()
                                    } else {
                                        that.messageBoxClose()
                                        setTimeout(function () {
                                            that.messageBoxOpen()
                                        }, 500)
                                    }
                                    this.rev_notice() // 消息通知同步调整
                                } else if (data.message.value.indexOf('access reservation') > -1) {
                                    // 预约单处理转等待会面
                                    that.rez_create()
                                    this.getRezNumber()
                                } else if (data.message.value.indexOf('complete reservation') > -1
                                    || data.message.value.indexOf('interrupt reservation') > -1) {
                                    this.getRezNumber()
                                    // 会面完成或中断会面
                                    that.work_num = that.work_num - 1;
                                    that.rez_create()
                                } else if (data.message.value.indexOf('reservation noresponse') > -1) {
                                    that.timeout_visible = true
                                    if (that.is_voice_open) {
                                        that.audio_src = that.noresponse_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }
                                    if (!that.message_box_is_open) {
                                        that.messageTimesOutOpen()
                                    } else {
                                        that.messageTimesOutClose()
                                        setTimeout(function () {
                                            that.messageTimesOutOpen()
                                        }, 500)
                                    }
                                    this.rev_notice() // 消息通知同步调整
                                } else if (data.message.value.indexOf('doctor_chat') > -1) {

                                    if (that.is_voice_open) {
                                        that.audio_src = that.doctor_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }

                                    let msg_content = JSON.parse(data.message.value.replace('doctor_chat', ''));
                                    this.doctor_users.push({
                                        user_name: msg_content.user_name,
                                        doctor_name: msg_content.doctor_name,
                                        user_id: msg_content.user_id,
                                        doctor_id: msg_content.doctor_id,
                                    })
                                    // let doctor_user = this.doctor_users
                                    let doctor_user =  this.removeDuplicateObj(this.doctor_users)
                                    this.rev_notice() // 消息通知同步调整
                                    this.noReplyReload();

                                    this.doctor_users = doctor_user

                                    this.messageDoctorOpen()
                                } else if (data.message.value.indexOf('doctor_reply_chat') > -1) {
                                    this.noReplyReload();
                                } else if (data.message.value.indexOf('health_record_update') > -1) {

                                    if (that.is_voice_open) {
                                        that.audio_src = that.doctor_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }

                                    let msg_content = JSON.parse(data.message.value.replace('health_record_update', ''));
                                    this.healthrecord_users.push({
                                        user_name: msg_content.user_name,
                                        doctor_name: msg_content.doctor_name,
                                        user_id: msg_content.user_id,
                                        doctor_id: msg_content.doctor_id,
                                    })
                                    let healthrecord_users = this.removeDuplicateObj(this.healthrecord_users)
                                    this.rev_notice() // 消息通知同步调整
                                    this.healthrecord_users = healthrecord_users
                                    this.messageRecordUpdateOpen()
                                    this.meetRecordReload();
                                } else if (data.message.value.indexOf('healthrecord_timeout') > -1) {
                                    if (that.is_voice_open) {
                                        that.audio_src = that.default_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }
                                    this.meetRecordReload();
                                } else if (data.message.value.indexOf('doctor_salary_contract_un_esign') > -1) {
                                    this.doctorSalaryEsignCount();
                                }  else if (data.message.value.indexOf('user_apply_submit') > -1) {
                                    that.apply_visible = true
                                    if (that.is_voice_open) {
                                        that.audio_src = that.apply_audio
                                        setTimeout(function () {
                                            that.$refs['alertAudioEl'].play() // 语音提醒
                                        }, 200)
                                    }
                                    if (!that.message_box_is_open) {
                                        that.userApplyOpen()
                                    } else {
                                        that.userApplyClose()
                                        setTimeout(function () {
                                            that.userApplyOpen()
                                        }, 500)
                                    }
                                } else if (data.message.value.indexOf('user_apply_deal') > -1) {
                                    this.userApplyCount()
                                }


                            }

                        } catch (e) {
                            // 数据异常
                        }
                    })
                    ws.addEventListener('error', e => {
                        if (status === 1) {
                            status = 2
                            connectNum++
                            // dispatch('connect')
                        }
                    })
                    ws.addEventListener('close', e => {
                        if (status === 1) {
                            status = 2
                            connectNum++
                        }
                    })
                    // commit('SET_WS', ws)
                    // resolve()
                }
            },
            immediate: true
        },
        message(val) {
            this.newReload();
        },
        $route: {
            handler(val, oldVal) {
                if (isMobile()) {
                    let app_id = document.getElementById('app')
                    if (this.$route.name === 'expertVisits') {
                        app_id.style.minWidth = "600px";
                    } else {
                        app_id.style.minWidth = "840px"
                    }
                }

                let path = val.meta.activeMenu || val.path;
                this.currentRoute = path;
                let routes = this.$store.getters.currentRoute.matched;
                let submenu = routes[1].name
                let submenu_child = ''
                if (routes[2] != undefined) {
                    submenu_child = routes[2].name
                }
                if (routes[routes.length - 1] != undefined) {
                    if (routes[routes.length - 1].meta.isSidebarItem != 1 && routes[2].meta.menu_parent) {
                        // 当前页面不在左侧显示时需修改submenu_child
                        submenu_child = routes[2].meta.menu_parent
                    }
                }

                let sidebarData = this.sidebarData
                let childSidebarData = null
                let childSidebarDataLen = 0
                let sidebarDataLen = sidebarData.length
                let sidebar_name = ''
                let dhild_sidebar_name = ''
                if (sidebarDataLen > 0) {

                    for (let i = 0; i < sidebarDataLen; i++) {
                        sidebar_name = sidebarData[i].name
                        if (sidebar_name === submenu || sidebar_name === submenu_child) {
                            this.sidebarData[i].menu_active = 'actived'
                        } else {
                            this.sidebarData[i].menu_active = ''
                        }
                        if (sidebarData[i].children) {
                            childSidebarData = sidebarData[i].children
                            childSidebarDataLen = childSidebarData.length
                            for (let j = 0; j < childSidebarDataLen; j++) {
                                dhild_sidebar_name = childSidebarData[j].name
                                if (dhild_sidebar_name === submenu || dhild_sidebar_name === submenu_child) {
                                    this.sidebarData[i].children[j].menu_active = 'actived'
                                } else {
                                    this.sidebarData[i].children[j].menu_active = ''
                                }
                            }
                        }
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    directives: {
        menu: {
            // 解决 el-menu 缩小的卡顿。
            bind(el) {
                el.style.transition = "all 0s";
            }
        }
    },
    methods: {
        removeDuplicateObj(doctor_user){
            doctor_user.reverse(); // 调转顺序，从后往前查重
            // 缓存用于记录
            const newArr = [];
            for (const t of doctor_user) {
                // 检查缓存中是否已经存在
                if (
                    newArr.find(
                        (c) =>
                            c.user_id === t.user_id &&
                            c.doctor_id === t.doctor_id
                    )
                ) {
                    // 已经存在说明以前记录过，现在这个就是多余的，直接忽略
                    continue;
                }
                // 不存在就说明以前没遇到过，把它记录下来
                newArr.push(t);
            }
            newArr.reverse(); // 恢复顺序
            // 记录结果就是过滤后的结果
            return newArr;
        },
        // 聊天详情
        goChatDetail(index) {
            let doctor_id = this.doctor_users[index].doctor_id
            let user_id = this.doctor_users[index].user_id
            let user_name = this.doctor_users[index].user_name
            let doctor_name = this.doctor_users[index].doctor_name

            this.messageDoctorClose(index)

            if (this.$route.name !== 'oneChatLogDetail') {
                this.$router.push({
                    name: "oneChatLogDetail",
                    params: {
                        user_id: doctor_id,
                        obj_id: user_id,
                        friend_name: user_name,
                        own_name: doctor_name,
                    }
                });
            } else {
                this.chat_no_reply(doctor_id, user_id, user_name, doctor_name);
            }

        },
        // 健康档案更新日志
        gohealthrecordsDetail(index) {
            let user_name = this.healthrecord_users[index].user_name
            let doctor_name = this.healthrecord_users[index].doctor_name

            this.messageRecordUpdateClose(index)
            if (this.$route.name !== 'healthrecordLogList') {
                this.$router.push({
                    name: "healthrecordLogList",
                    params: {
                        user_name: user_name,
                        doctor_name: doctor_name,
                    }
                });
            } else {
                this.health_record_log(user_name, doctor_name);
            }

        },
        // 创建预约单消息通知
        async messageBoxOpen() {
            let _that = this
            await this.getRezNumber()

            let notice_box = document.getElementById('notice_box')
            notice_box.classList.remove('hidden')
            notice_box.classList.remove('notice_hidden')
            this.notice_box = this.first_index
            this.timesout_box = this.second_index
            this.doctor_box = this.second_index
            this.healthrecord_box = this.second_index
            notice_box.classList.add('notice_show')

            _that.message_box_is_open = true;

        },
        messageBoxClose(is_hidden = 0) {
            let notice_box = document.getElementById('notice_box')
            notice_box.classList.remove('notice_show')
            notice_box.classList.add('notice_hidden')
            if (is_hidden) {
                notice_box.classList.add('hidden')
            }
            this.message_box_is_open = false;

        },

        // 未响应预约单消息通知
        async messageTimesOutOpen() {
            let _that = this
            await this.getTimesOutNumber()

            let notice_box = document.getElementById('notice_timesout_box')
            notice_box.classList.remove('hidden')
            notice_box.classList.remove('notice_hidden')
            this.timesout_box = this.first_index
            this.notice_box = this.second_index
            this.doctor_box = this.second_index
            this.healthrecord_box = this.second_index
            notice_box.classList.add('notice_show')

            _that.message_box_is_open = true;

        },
        messageTimesOutClose(is_hidden = 0) {
            let notice_box = document.getElementById('notice_timesout_box')
            notice_box.classList.remove('notice_show')
            notice_box.classList.add('notice_hidden')
            if (is_hidden) {
                notice_box.classList.add('hidden')
            }
            this.message_box_is_open = false;

        },
        // 注册申请提交消息通知
        async userApplyOpen() {
            let _that = this
            await this.userApplyCount()

            let apply_box = document.getElementById('notice_apply_box')
            apply_box.classList.remove('hidden')
            apply_box.classList.remove('notice_hidden')
            this.apply_box = this.first_index
            this.timesout_box = this.second_index
            this.notice_box = this.second_index
            this.doctor_box = this.second_index
            this.healthrecord_box = this.second_index
            notice_box.classList.add('notice_show')

            _that.message_box_is_open = true;
            this.user_apply(this.user_apply_count)

        },
        userApplyClose(is_hidden = 0) {
            let apply_box = document.getElementById('notice_apply_box')
            apply_box.classList.remove('notice_show')
            apply_box.classList.add('notice_hidden')
            if (is_hidden) {
                apply_box.classList.add('hidden')
            }
            this.message_box_is_open = false;

        },
        // 超时未回复消息通知
        async messageDoctorOpen() {
            let _that = this
            setTimeout(function () {

            }, 500)
            let doctor_chat_id_obj = null;
            this.doctor_box = this.first_index
            this.notice_box = this.second_index
            this.timesout_box = this.second_index
            this.healthrecord_box = this.second_index
            for (let i = 0; i < this.doctor_users.length; i++) {
                doctor_chat_id_obj = null;
                doctor_chat_id_obj = document.getElementById("doctor_chat_" + i)

                if (doctor_chat_id_obj) {
                    doctor_chat_id_obj.classList.remove('hidden')
                    doctor_chat_id_obj.classList.remove('notice_hidden')
                    // this.doctor_box = this.first_index + i
                    // this.notice_box = this.second_index
                    // this.timesout_box = this.second_index
                    // this.healthrecord_box = this.second_index
                    doctor_chat_id_obj.classList.add('notice_show')
                }

            }

        },
        messageDoctorClose(index) {
            this.doctor_users.splice(index)

        },
        // 健康档案更新通知
        async messageRecordUpdateOpen() {
            let _that = this
            setTimeout(function () {

            }, 500)
            let health_record_id_obj = null;
            this.healthrecord_box = this.first_index
            this.doctor_box = this.second_index
            this.notice_box = this.second_index
            this.timesout_box = this.second_index
            for (let i = 0; i < this.healthrecord_users.length; i++) {
                health_record_id_obj = null;
                health_record_id_obj = document.getElementById("health_record_" + i)

                if (health_record_id_obj) {
                    // this.healthrecord_box = this.first_index + i
                    // this.doctor_box = this.second_index
                    // this.notice_box = this.second_index
                    // this.timesout_box = this.second_index
                    health_record_id_obj.classList.remove('hidden')
                    health_record_id_obj.classList.remove('notice_hidden')
                    health_record_id_obj.classList.add('notice_show')
                }

            }
        },
        messageRecordUpdateClose(index) {
            this.healthrecord_users.splice(index)

        },
        findRoute(routes, path) {
            if (Array.isArray(routes)) {
                return routes.filter(routes => routes.path == path).pop();
            }
        },

        // 打开关闭侧边栏
        collapse() {
            this.isCollapse = !this.isCollapse;
            this.$store.commit("SET_COLLAPSE", this.isCollapse);
        },

        openANewPage() {
            const route = this.$router.resolve({name: "panel"});
            window.open(route.href, "_blank");
        },
        reload() {

            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'allReservationNumber',
                params: {
                    status: [1],
                },
            };
            this.$api.service(params).then(res => {
                if (res.data.code != "0") {
                    return;
                }

                sessionStorage.setItem("reservationing_number", res.data.data.number);
                this.work_num = res.data.data.number;

            });
            this.work_num = 0;            //先关闭，
            this.$nextTick(function () {
                this.work_num = sessionStorage.getItem("reservationing_number");         //再打开
            })
        },
        // 获取超时未回复数
        noReplyReload() {
            let params = {
                servername: 'Ruyi_chatAdminServices',
                method: 'noReplyCount',
                params: {},
            };
            this.$api.service(params).then(res => {
                if (res.data.code != "0") {
                    return;
                }
                this.no_reply_count = res.data.data.number;
            });
        },
        // 获取健康档案未及时更新统计数
        meetRecordReload() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'meetRecordeCount',
                params: {},
            };
            this.$api.service(params).then(res => {
                if (res.data.code != "0") {
                    return;
                }
                this.meet_record_count = res.data.data.number;
            });
        },
        // 获取会面超时统计数
        meetTimeoutReload() {
                let params = {
                    servername: 'Ruyi_AdminWorkbenchServices',
                    method: 'listing',
                    params: {
                        count_num: 1,
                        status: 2,
                        meet_time_out:1,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.meet_timeout_count = res.data.data.number;
                });


        },
        // 专家服务费结算报告超时未签字统计
        doctorSalaryEsignCount() {
            let params = {
                servername: 'Ruyi_StatementsServices',
                method: 'doctorSalaryEsignCount',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.doctor_salary_esign_count = res.data.data.number;
            });


        },
        // 专家服务费结算报告超时未签字统计
        userApplyCount() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'userApplyCount',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.user_apply_count = res.data.data.number;
                if (res.data.data.number < 1) {
                    this.apply_visible = false
                }
            });


        },
        newReload() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'unReservationNumber',
                params: {},
            };
            this.$api.service(params).then(res => {
                if (res.data.code != "0") {
                    return;
                }

                sessionStorage.setItem("reservationing_number", res.data.data.number);
                this.work_num = res.data.data.number;


            });
        },
        // 所有未处理的预约数量
        getRezNumber() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'allReservationStatusNumber',
                params: {
                    status: [1],
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data && res.data.data.length > 0) {
                    this.revesion_num = res.data.data[0].number
                    if (res.data.data[0].number < 1) {
                        this.revesion_visible = false
                    }
                }
                this.getTimesOutNumber()
            });
        },
        // 未响应的预约数量
        getTimesOutNumber() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'allReservationStatusNumber',
                params: {
                    status: [1],
                    timeout_times: 2,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data && res.data.data.length > 0) {
                    this.revesion_times_out_num = res.data.data[0].number
                    if (res.data.data[0].number < 1) {
                        this.timeout_visible = false
                    }

                }
            });
        },
        getAuthUrl() {

            let params = {
                servername: 'Ruyi_AdminSystemServices',
                method: 'authUrl',
            };
            this.$api.service(params).then(res => {
                if (res.data.code != "0") {
                    return;
                }
                if (res.data.data.length) {
                    let authUrl = [];
                    for (let i = 0; i < res.data.data.length; i++) {
                        authUrl.push(res.data.data[i].path)
                    }
                    this.$store.commit('SET_AUTH_URL', authUrl)
                }


            });
        },
        gernerateId(index) {
            return "doctor_chat_" + index
        },
        healthRecordGernerateId(index) {
            return "health_record_" + index
        }
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";
@import "@/styles/iconfont.scss";

.sidebar {
    background: white;
    width: 210px;
    height: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 60px;
    border-right: solid 1px $borderColor;
    z-index: 99;
    transition: width 0.28s;

    .el-menu {
        border-right: 0;
    }

    .el-submenu .el-menu-item {
        min-width: 100%;
        padding-right: 10px;
    }

    .el-submenu,
    .el-menu-item {
        text-align: left;
        div {

        }
    }

    .rotate-left {
        transform: rotate(-180deg);
    }

    .collapse-btn {
        background: white;
        position: absolute;
        right: -21px;
        top: 50%;
        height: 50px;
        width: 20px;
        text-align: center;
        line-height: 50px;
        margin-top: -25px;
        border-right: 1px solid $borderColor;
        border-top: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        z-index: 100;

        & > span {
            display: inline-block;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -8px;
            margin-top: -8px;
        }
    }

    i[class^="icon-"] {
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
        margin-right: 10px;
        width: 18px;
        height: 24px;
    }

    i.icon-home-gray {
        background-image: url(../assets/home_gray.png);
    }

    i.icon-engineering-gray {
        background-image: url(../assets/icon_engineering_gray.png);
    }

    i.icon-forum-gray {
        background-image: url(../assets/forum_gray.png);
    }

    i.icon-order-gray {
        background-image: url(../assets/order_gray.png);
    }

    i.icon-content-gray {
        background-image: url(../assets/content_gray.png);
    }

    i.icon-unit-gray {
        background-image: url(../assets/icon_unit_gray.png);
    }

    i.icon-withdrawal-gray {
        background-image: url(../assets/withdrawal_gray.png);
    }

    i.icon-invoice-gray {
        background-image: url(../assets/invoice_gray.png);
    }

    i.icon-setting-gray {
        background-image: url(../assets/icon_setting_gray.png);
    }

    i.icon-expo-gray {
        background-image: url(../assets/icon-expo-gray.png);
    }

    i.icon-health-square-gray {
        background-image: url(../assets/icon-health-square-gray.png);
    }

    i.icon-information-gray {
        background-image: url(../assets/icon-information-gray.png);
    }

    .el-menu {
        & .is-active {
            color: $dominantHue;
        }

        & .is-opened,
        & .is-active {
            i.icon-home-gray {
                background-image: url(../assets/home_blue.png);
            }

            i.icon-engineering-gray {
                background-image: url(../assets/icon_engineering_blue.png);
            }

            i.icon-forum-gray {
                background-image: url(../assets/forum_blue.png);
            }

            i.icon-order-gray {
                background-image: url(../assets/order_blue.png);
            }

            i.icon-content-gray {
                background-image: url(../assets/content_blue.png);
            }

            i.icon-unit-gray {
                background-image: url(../assets/icon_unit_blue.png);
            }

            i.icon-withdrawal-gray {
                background-image: url(../assets/withdrawal_blue.png);
            }

            i.icon-invoice-gray {
                background-image: url(../assets/invoice_blue.png);
            }

            i.icon-setting-gray {
                background-image: url(../assets/icon_setting_blue.png);
            }

            i.icon-expo-gray {
                background-image: url(../assets/icon-expo-blue.png);
            }

            i.icon-health-square-gray {
                background-image: url(../assets/icon-health-square-blue.png);
            }

            i.icon-information-gray {
                background-image: url(../assets/icon-information-blue.png);
            }
        }
    }
}
li[data-actived="actived"] {
    background-color: #ecf5ff;
    color: #6B99F0;
}
.hide-sidebar {
    width: 64px;

    .el-submenu {
        overflow: hidden;

        & > .el-submenu__title {
            .el-submenu__icon-arrow {
                display: none;
            }
        }
    }

    .el-menu--collapse {
        .el-submenu {
            & > .el-submenu__title {
                & > span {
                    height: 0;
                    width: 0;
                    overflow: hidden;
                    visibility: hidden;
                    display: inline-block;
                }
            }
        }
    }
}

.test {
    .el-badge__content.is-fixed {
        top: 20px;
        right: 9px;
        color: #F56C6C;
    }
}

.el-menu.el-menu--inline {
    .test {
        .el-badge__content.is-fixed {
            top: 16px;
            right: 9px;
            color: #F56C6C;
        }
    }
}

.el-badge__content {
    width: 0;
    height: 0;
    text-shadow: 2px 1px 3px #a3a3a3;
    background-color: none;
    line-height: 0;
    font-size: 21px;
    border: none;
}

.notice_content_box {
    .el-message.is-closable {
        top: 20px;
        padding: 5px 15px;
        border: none;
        background: #fff;
        color: #000;
        width: 680px;
        //box-shadow: 0 0 4px 0 rgba(20, 20, 50 , 0), 0 2px 4px 0 rgba(20, 20, 50  , 2%);
        .el-message__icon.el-icon-tickets.el-message__icon_color {
            font-size: 1.2em;
            font-weight: bold;
            color: #f56c6c;
        }

        div.el-message__content {
            text-align: left;
            //min-width: 360px;
            width: 100%;
            line-height: 1.5em;
            padding: 15px 15px 15px 0;

            div > div > i {
                color: #f56c6c;
                font-style: normal;
                font-weight: bold;
                font-size: 1.5em
            }

            div.mssage_revestion.el-button.el-button--primary {
                margin-left: 1em;
                cursor: pointer;
                float: right;
                padding: 0.5em 1.2em;
                font-size: 0.8em;
                background: #019ae8;
            }
        }
    }
}

.notice_show {
    //display: flex;
    animation: notice_show 0.5s linear;
    animation-fill-mode: forwards;
}

.notice_hidden {
    display: flex;
    animation: notice_hidden 0.5s linear;
    animation-fill-mode: forwards;
}

.hidden {
    display: none;
}

#go_reservation, #notice_close, #go_noresponse {
    box-sizing: border-box;
    padding: 5px;
    //border: 1px solid #ff0000;
    border-radius: 5px;
    border: none;
}

@keyframes notice_show {
    from {
        top: -60px;
    }
    to {
        top: 20px;
    }
}

@keyframes notice_hidden {
    from {
        top: 20px;
    }
    to {
        top: -60px;
    }
}
.iconfont{
    margin-right: 5px;
    width: 18px;
    text-align: center;
    vertical-align: middle;
}
.icon-zhuli{
    font-size: 22px !important;
}
.icon-zhuanjia{
    font-size: 20px !important;
}
.icon-expert{
    font-size: 22px !important;
}
.icon-record-full,.icon-meet {
    font-size: 16px !important;
}

</style>


